import { initOrUpdateSession } from './utils'

export default {
	initOrUpdateSession,
}
